import { createSelector } from "@reduxjs/toolkit";
import getFiltersString from "../../client/adverts/getFiltersString";
import { getPages } from "../../state/modules/search";
import { getAllAppliedRefinements } from "../../state/modules/facets";
import { getSponsoredProductCount } from "../../state/modules/search/advertising/selectors";

export const getFirstPageProductCount = createSelector([getPages], (pages) => {
  const firstPage = pages.find(({ pageNumber }) => pageNumber === 1);

  return firstPage?.products.length ?? 0;
});

export const getCriteoSerialisedFilters = createSelector(
  [getAllAppliedRefinements],
  (appliedRefinements) => getFiltersString(appliedRefinements),
);

export const getCriteoListSize = createSelector(
  [getFirstPageProductCount, getSponsoredProductCount],
  (firstPageProductCount, sponsoredProductCount) =>
    firstPageProductCount - sponsoredProductCount,
);
